export default __webpack_public_path__ + "static/media/3.6e542e33.jpg";